import type { ReactNode } from "react"
import { cn } from "@/lib/utils"
import { Label } from "../Label/Label"

export interface AuthFieldProps {
  label: ReactNode
  error?: ReactNode
  action?: ReactNode
  children: ReactNode
  className?: string
}

export function AuthField({ label, error, action, children, className }: AuthFieldProps) {
  return (
    <div className={cn("space-y-1.5", className)}>
      {action ? (
        <div className="flex items-center justify-between">
          <Label className="text-caption font-medium text-muted-foreground">{label}</Label>
          {action}
        </div>
      ) : (
        <Label className="text-caption font-medium text-muted-foreground">{label}</Label>
      )}
      {children}
      {error && <p className="text-caption text-destructive">{error}</p>}
    </div>
  )
}
